import { useClearFilter, useGetMainFilterApplied, useSetMainFilter } from '../publicCatalogFiltersHooks';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { SearchInput } from 'foundations-components/transitional/components/SearchInput';
import debounce from 'react-utils/debounce';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import useSearchParams from 'academy-common-lib/hooks/useSearchParams';
import { useEffect, useRef } from 'react';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const DEBOUNCE_DELAY = 800;
const PublicCatalogSearchInput = () => {
  const {
    isMobile
  } = useMediaQuery();
  const [searchParams] = useSearchParams();
  const setMainFilter = useSetMainFilter();
  const clearFilter = useClearFilter();
  const searchInputRef = useRef(null);
  const mainFilterApplied = useGetMainFilterApplied();
  useEffect(() => {
    // Clear search input if search param is removed from URL (eg. if another primary filter is applied)
    if (!searchParams.search && searchInputRef.current) {
      searchInputRef.current.value = '';
    }
  }, [searchParams.search]);
  const debouncedSetMainFilter = debounce(setMainFilter, DEBOUNCE_DELAY);
  const handleSearchInputChange = searchValue => {
    // only clear the filter if the search filter is applied
    if (searchValue === '' && searchParams.search) {
      clearFilter('search');
      debouncedSetMainFilter.reset();
      return;
    }
    if (searchValue === '' && !searchParams.search) {
      return;
    }
    debouncedSetMainFilter('search', searchValue);
  };
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FormControl, {
      "aria-label": I18n.text('academyPublic.catalogPage.filters.searchInputLabel'),
      children: /*#__PURE__*/_jsx(SearchInput, {
        blockSize: !isMobile ? '60px' : undefined,
        defaultValue: mainFilterApplied === 'search' ? searchParams.search : '',
        inputRef: searchInputRef,
        onChange: event => handleSearchInputChange(event.target.value),
        paddingBlock: !isMobile ? '500' : undefined,
        paddingInline: !isMobile ? '250' : undefined
      })
    })
  });
};
export default PublicCatalogSearchInput;